import {ServiceBase} from "../ServiceBase";
import {
    ICashierGnwpRequest,
    IGameGnwpRequest,
    IGnwpService, ILiveChatGnwpRequest,
    IMyAccountGnwpRequest,
    IOmgGnwpRequest,
    IPendingAppGnwpRequest,
    IPendingLoginGnwpRequest,
    IPendingPlayGnwpRequest, IPokerGnwpRequest,
    IRegistrationGnwpRequest,
    IRichPageGnwpRequest, ISportGnwpRequest
} from "./gnwp.service.interface";
import {IGNWPRequestModel} from "../../../sdk/src/services/gnwp/gnwp_service_interface";
import {Check} from "@sparkware/app-utils";
import {GNWP_SOURCES} from "./gnwp-consts";

export class GnwpService extends ServiceBase implements IGnwpService {

    async getGameUrl(request: IGameGnwpRequest): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: request.templateName,
            isReal: request.isReal,
            gameType: request.gameType,
            currencyCode: this.services.currency.currencyIso3,
            externalGameCode: request.externalGameCode,
            isHistory: request.isHistory || false,
            gameId: request.historyGameRoundId,
            historyRoundStartDate: request.historyRoundStartDate,
            token: request.token
        };

        if(!Check.isUndefined(request.gameLimit)) {
            gnwpRequest.gameLimit = request.gameLimit;
        }

        if(!Check.isUndefined(request.requestedGameLimit)) {
            gnwpRequest.requestedTimeLimit = request.requestedGameLimit;
        }

        if(!Check.isUndefined(request.requestedTimeLimit)) {
            gnwpRequest.requestedTimeLimit = request.requestedTimeLimit;
        }
        if(!Check.isUndefined(request.restrictionPeriod)) {
            gnwpRequest.restrictionPeriod = request.restrictionPeriod;
        }
        if(!Check.isUndefined(request.intervalReminder)) {
            gnwpRequest.intervalReminder = request.intervalReminder;
        } else {
            gnwpRequest.intervalReminder = 0;
        }

        if(!Check.isUndefined(request.historyGameRoundId)) {
            gnwpRequest.gameId = request.historyGameRoundId;
        }

        if(!Check.isUndefined(request.target)) {
            gnwpRequest.target = request.target;
        }

        if(!Check.isUndefined(request.isOSS)) {
            gnwpRequest.isOSS = request.isOSS;
        }

        //We use it only for AOD NYX
        if(!Check.isUndefined(request.NyxLinkID)) {
            gnwpRequest.NyxLinkID = request.NyxLinkID;
        }

        if(!Check.isUndefined(request.NetEntGameHistoryLinkID)) {
            gnwpRequest.NetEntGameHistoryLinkID = request.NetEntGameHistoryLinkID;
        }

        if(!Check.isNullOrUndefined(request.hasInGameHistory)) {
            gnwpRequest.hasInGameHistory = request.hasInGameHistory;
        }

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);

        return gnwpResponse.getGNWPUrl();
    }

    async getMyAccountUrl(request: IMyAccountGnwpRequest): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.MY_ACCOUNT,
            isReal: true,
            target: 2
        }

        if(!Check.isNullOrUndefined(request.tabId)) {
            gnwpRequest.tabId = request.tabId;
        }

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);

        return gnwpResponse.getGNWPUrl();
    }

    async getRegistrationUrl(request: IRegistrationGnwpRequest): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.MEMBERSHIP,
            isReal: false,
            target: 2,
            marketingData: request.marketingData
        }
        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);

        return gnwpResponse.getGNWPUrl();
    }

    async getCashierUrl(request: ICashierGnwpRequest): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.CASHIER,
            isReal: true,
            target: request.target,
            isMobile: this.services.device.os.isMobileOS || this.services.device.isProbablyIOSDevice
        }

        if(!Check.isNullOrUndefined(request.sessionType)) {
            gnwpRequest.sessionType = request.sessionType;
        }

        if(!Check.isNullOrUndefined(request.promCode)) {
            gnwpRequest.PromCode = request.promCode;
        }

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);

        return gnwpResponse.getGNWPUrl();
    }

    async getOmgUrl(request: IOmgGnwpRequest): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.OMG,
            isReal: true,
            target: 2,
            ExternalLinkInPopUp: 1,
            Messages: request.messages,
            OpenedWithinGame: request.openedWithinGame
        }

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);

        return gnwpResponse.getGNWPUrl();
    }

    async getForgotUserNameUrl(): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.FORGOT_USERNAME,
            isReal: false,
            target: 2
        };

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);
        return gnwpResponse.getGNWPUrl();
    }

    async getForgotPasswordUrl(): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.FORGOT_PASSWORD,
            isReal: false,
            target: 2
        };

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);
        return gnwpResponse.getGNWPUrl();
    }

    async getPendingLoginUrl(request: IPendingLoginGnwpRequest): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.PENDING_LOGIN,
            target: 2,
            token: request.token,
            businessCorrelationId: this.services.playerMigration.businessCorrelationId
        };

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);
        return gnwpResponse.getGNWPUrl();
    }

    async getPendingPlayUrl(request: IPendingPlayGnwpRequest): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.PENDING_PLAY,
            target: 2,
        };

        if(request.token) {
            gnwpRequest.token = request.token;
        }

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);
        return gnwpResponse.getGNWPUrl();
    }

    async getPendingAppUrl(request: IPendingAppGnwpRequest): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.PENDING_APP,
            target: 2,
            pendingActionEventTypeId: request.eventTypeId,
            pendingActionEventTypeName: request.eventTypeName,
            pendingActionTargetProductPackageId: request.pendingActionTargetProductPackageId
        };

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);
        return gnwpResponse.getGNWPUrl();
    }
    
    async getUploadDocumentsUrl(): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.DOCUMENT_UPLOAD,
            target: 2
        };

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);
        return gnwpResponse.getGNWPUrl();
    }

    async getContactUsUrl(): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.CONTACT_US,
            target: 1
        };

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);
        return gnwpResponse.getGNWPUrl();
    }

    async getRichPageUrl(request: IRichPageGnwpRequest): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.RICH,
            target: 2,
            marketingCampaignId: request.marketingCampaignId
        };

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);
        return gnwpResponse.getGNWPUrl();
    }

    async getHelpPageUrl(): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.HELP,
            target: 1,
        };

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);
        return gnwpResponse.getGNWPUrl();
    }

    async getPokerUrl(options: IPokerGnwpRequest): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.POKER,
            target: 1,
            marketingData: this.services.marketing.getMarketingData(options.marketingParams)
        };

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);
        return gnwpResponse.getGNWPUrl();
    }

    async getSportUrl(options: ISportGnwpRequest): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.SPORT,
            target: 1,
            marketingData: this.services.marketing.getMarketingData(options.marketingParams)
        };

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);
        return gnwpResponse.getGNWPUrl();
    }
    getTempAccountGnwpSource(): GNWP_SOURCES {
        return this.services.sdk.getTempAccountGnwpSource();
    }

    async getLiveChatUrl(options: ILiveChatGnwpRequest): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: GNWP_SOURCES.LIVE_CHAT,
            target: 1,
            marketingData: this.services.marketing.getMarketingData(options.marketingParams)
        };

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);
        return gnwpResponse.getGNWPUrl();
    }
}